import { getAll } from '@/api/ligneCommande/index';
import * as allTypes from '@/store/mutation-type';
import genererCritereRechercheDemandeTempo
  from '@/services/bodac/demandeTempo/genererCritereRechercheDemandeTempo';
import { get } from '@/api/devis/index';
import getTabDemandesTempo from '@/services/bodac/demandeTempo/getTabDemandesTempo';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import * as types from './demandeTempo-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRechercheDemandeTempo(),
    devis: [],
    lignesAvertissement: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_DEVIS](state, devis) {
    state.devis = devis;
  },
  [types.SET_LIGNES_AVERTISSEMENT](state, lignesAvertissement) {
    state.lignesAvertissement = lignesAvertissement;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadDemandeTempo({ commit, state }, data) {
    const rslt = (await getAll(data)).data.result;
    let devisIds = rslt.items.filter((item) => {
      return item.etatSouhaite !== AUCUN;
    }).map((item) => item.devisCommande.id);
    devisIds = [...new Set(devisIds)];
    const promiseDevis = [];
    devisIds.forEach((id) => {
      promiseDevis.push(get(id));
    });
    const devis = (await Promise.all(promiseDevis)).map(rsltDevis => rsltDevis.data.result);
    const demandes = getTabDemandesTempo(rslt.items, devis, state.lignesAvertissement);
    commit(types.SET_LIGNES_AVERTISSEMENT, []);
    commit(types.SET_DEVIS, devis);
    commit(types.SET_ITEMS, demandes);
    commit(types.SET_TOTAL, rslt.totalCount);
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  devis: state => {
    return state.devis;
  },
  lignesAvertissement: state => {
    return state.lignesAvertissement;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
